/* eslint-disable no-nested-ternary */
import {
  Button,
  Chip,
  Grid,
  Tooltip,
} from '@material-ui/core';
import { DateRange, Description, Event } from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import { getPostuleCandidatureEntreprise } from '@webapps/business';
import {
  PaginationNumbers,
  useAuth,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { withStyles } from '@material-ui/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

const BusinessPostule = ({ handleEmploiLength }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const { push } = useRouter();
  const { idUser } = useAuth();

  const [page, setPage] = useState(1);
  const [anchorCandid, setAnchorCandid] = useState(null);

  const goToMyMap = () => {
    push(ROUTES_PATH.MYMAP, { params: { id: idUser } });
  };

  const {
    status: load,
    data: { content: offers = [], totalElements } = {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isFetching,
  } = useQuery(getPostuleCandidatureEntreprise, {
    key: ['postuleOffers', page],
    variables: { id: idUser, page: page - 1, size: 8 },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    handleEmploiLength(totalElements);
  }, [totalElements]);

  return (
    <div>
      <Grid
        container
        style={
          offers.length === 0
            ? {
              display: 'flex',
              justifyContent: 'center',
              padding: spacing(2.5),
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
            }
            : {
              display: 'flex',
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
              height: '100%'
            }
        }
      >
        {!offers.length ? (
          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid
              item
              className={css({
                backgroundColor: '#FFFFFF',
                borderRadius: 12,
                padding: '30.0px',
                '@media screen and (max-width: 768px)': {
                  padding: '20px',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h1
                  className={cx(css({
                    textAlign: 'center',
                    margin: '0px 0px 30px 0px',
                  }), global.title)}
                >
                  {' '}
                  Commencez à rechercher des offres d'emploi
                </h1>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  1. Accédez à la recherche d'offres d'emploi de nos entreprises partenaires
                </p>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  2. Triez les offres d'emploi selon vos critères de recherche et candidatez en un clic.
                </p>
                <p
                  style={{ textAlign: 'center', margin: '5px 5px 30px 5px' }}
                >
                  {' '}
                  3. Soyez informé par les entreprises pour les offres d'emploi auxquelles vous avez candidatez.
                </p>
                <Button
                  className={classes.btn}
                  color="primary"
                  variant="contained"
                  onClick={goToMyMap}
                  disableElevation={true}
                >
                  Rechercher des offres
                </Button>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '20px' }} spacing={2}>
            {offers.map((info) => (
              <PostuledOffer
                applicationDate={info?.applicationDate}
                response={info?.response}
                offer={info?.offer}
              />
            ))}
          </Grid>
        )}
      </Grid>
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={8}
        totalCount={totalElements}
      />
    </div>
  );
};

const PostuledOffer = (applicationDate) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const { push } = useRouter();

  const goToBusiness = (idBusiness) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id: idBusiness } });
  };

  return (
    <Grid item xs={12} md={4} lg={3}>
      <Grid
        item
        className={css({
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#fff',
          borderRadius: 10,
          padding: '20px',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          })}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <AvatarCompany
              height={60}
              idCompany={applicationDate?.offer?.business?.id || applicationDate?.offer?.businessExternal}
              name={applicationDate?.offer?.business?.name || applicationDate?.offer?.businessExternal?.name}
              variant="circular"
              width={60}
            />
            <div style={{ marginLeft: spacing(3) }}>
              <div className={cx(global.title, classes.block)}>
                {applicationDate?.offer?.job?.label}{' '}
              </div>
              <div className={cx(global.infoText, classes.name)}>
                <div style={{ marginRight: '8px' }}>{applicationDate?.offer?.business?.name || applicationDate?.offer?.businessExternal?.name}</div>
                {applicationDate?.offer?.business?.name ? (
                  <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                ) : (
                  <div style={{color: "white", backgroundColor: '#152652', borderRadius: '6px', padding: '1px 5px', fontWeight: 600}}>Externe</div>
                )}
              </div>
            </div>
          </div>

          <div className={classes.divInfos}>
            <div className={cx(global.infoText, classes.address)}>
              <Description className={global.infoIcon} />
              {applicationDate?.offer?.contractType?.label}
            </div>
            <div className={cx(global.infoText, classes.address)}>
              <RoomIcon className={global.infoIcon} />
              {applicationDate?.offer?.business?.address?.cityCode || applicationDate?.offer?.businessExternal?.address?.cityCode}{' '}
              {applicationDate?.offer?.business?.address?.city || applicationDate?.offer?.businessExternal?.address?.city}
            </div>
            <div className={cx(global.infoText, classes.address)}>
              <DateRange className={global.infoIcon} />
              <div>
                Candidature du{' '}
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={applicationDate?.offer?.createdAt}
                  year="numeric"
                />{' '}
                au{' '}
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={applicationDate?.offer?.deadLine}
                  year="numeric"
                />
              </div>
            </div>
            <div className={cx(global.infoText, classes.address)}>
              <Event
                fontSize="small"
                className={css({ marginRight: spacing(1) })}
              />
              <div>
                Candidaté le{' '}
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={applicationDate?.applicationDate}
                  year="numeric"
                />
              </div>
            </div>
            <div>
              {applicationDate?.response === 'ACCEPTED' ? (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#dbfad8',
                      color: 'green',
                    }),
                  }}
                  className={classes.chip}
                  color="primary"
                  label="Candidature acceptée"
                  size="small"
                />
              ) : applicationDate?.response === 'REJECTED' ? (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#fbd3d5',
                      color: '#F50057',
                    }),
                  }}
                  className={classes.chip}
                  color="primary"
                  label="Candidature déclinée"
                  size="small"
                />
              ) : (
                <Chip
                  classes={{
                    colorPrimary: css({
                      background: '#FAE8D7 ',
                      color: '#FA8100',
                    }),
                  }}
                  className={classes.chip}
                  color="primary"
                  label="Candidature envoyée"
                  size="small"
                />
              )}
            </div>
          </div>
          <div style={{ marginTop: '20px' }}>
            {!applicationDate?.offer?.businessExternal ? (
              <Button
                fullWidth
                onClick={() => goToBusiness(applicationDate?.offer?.business?.id)}
                style={{ backgroundColor: '#F3F7FF', borderRadius: 10  }}
                variant="outlined"
              >
                <FormattedMessage id="vitrine.btnVoirEtablissement" />
              </Button>
            ) : (
              <LightTooltip title="Vous ne pouvez pas voir la vitrine d'une entreprise externe" placement="top">
                <div>
                  <Button
                    fullWidth
                    disabled
                    onClick={() => {}}
                    style={{ backgroundColor: '#F3F7FF', borderRadius: 10  }}
                    variant="outlined"
                  >
                    <FormattedMessage id="vitrine.btnVoirEtablissement" />
                  </Button>
                </div>
              </LightTooltip>
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  container: {
    padding: spacing(3),
    borderRadius: 10,
    border: '1px solid #E8E8E8',
    '&:first-child': { marginTop: 0 },
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  avatar: {
    height: 50,
    width: 50,
  },
  name: {
    color: '#152652',
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  timer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(0.5),
  },
  block: {
    display: 'flex',
    width: '100%',
  },
  chip: {
    marginTop: spacing(2),
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    borderRadius: '10.00px',
    '@media only screen and (max-width:768px)': {
      padding: spacing(1),
      maring: 0,
    },
  },
  divInfos: {
    marginTop: spacing(1),
    '@media only screen and (max-width:768px)': {
      margin: 0,
    },
  },
});

const LightTooltip = withStyles(({ shadows }) => ({
  tooltip: {
    backgroundColor: '#5D75A8',
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
  },
}))(Tooltip);

export default BusinessPostule;
